import { useReducer, useCallback } from "react";
import { MESSAGE_ACTION_TYPES } from "../constants/constants";


const useChatMessages = (initialMessages = []) => {
  const reducer = (state, action) => {
    switch (action.type) {
      case MESSAGE_ACTION_TYPES.ADD_MESSAGE:
        return [...state, action.payload];
      case MESSAGE_ACTION_TYPES.SET_MESSAGES:
        return action.payload;
      case MESSAGE_ACTION_TYPES.UPDATE_MESSAGE:
        return state.map((msg, idx) =>
          idx === action.index ? { ...msg, ...action.payload } : msg
        );
      default:
        return state;
    }
  };

  const [messages, dispatch] = useReducer(reducer, initialMessages);

  const addMessage = useCallback((message) => {
    dispatch({ type: MESSAGE_ACTION_TYPES.ADD_MESSAGE, payload: message });
  }, []);

  const setMessages = useCallback((messages) => {
    dispatch({ type: MESSAGE_ACTION_TYPES.SET_MESSAGES, payload: messages });
  }, []);

  return { messages, addMessage, setMessages, dispatch }; 
};

export default useChatMessages;


